import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getTranslations } from '@translations';
import { Navigation } from '@components';
import { menuLinkItems } from './constants';

import { useHeaderContext } from '../../../../HeaderContext';
import { MenuPropType } from '../../../../propTypes';

import stylesMenu from './styles/index.module.scss';

export const isBasket = type => type === 'basket';

const Menu = ({
  isB2B,
  isAuthenticated,
  basketCount,
  onToggle,
  classNames,
  isHidden,
}) => {
  const translations = getTranslations();
  const { platformBaseUrl } = useHeaderContext();
  const closeClassName = cn(classNames.mobileMenu, stylesMenu.closeMenuItems);

  return (
    <>
      {!isHidden &&
        menuLinkItems(isB2B, isAuthenticated, classNames).map(
          ({ id, icon, url, size, className, dataQaSelect, dataQaIcon }) => (
            <Navigation
              tag="a"
              key={id}
              icon={icon}
              url={`${platformBaseUrl}${translations(url)}`}
              size={size}
              className={className}
              dataQaSelect={dataQaSelect}
              dataQaIcon={dataQaIcon}
              isAuthenticated={isAuthenticated}
            >
              {isBasket(icon) && basketCount > 0 ? (
                <span
                  className={
                    isB2B ? stylesMenu.basketCountB2b : stylesMenu.basketCount
                  }
                  data-qa="quantityBasketElm"
                  data-quantity={basketCount}
                >
                  {basketCount}
                </span>
              ) : null}
            </Navigation>
          ),
        )}

      {!isHidden ? (
        <Navigation
          tag="button"
          icon="burgerMenu"
          className={classNames.mobileMenu}
          onClick={onToggle}
          dataQaSelect="selectMenuCta"
          dataQaIcon="iconMenuCta"
        />
      ) : (
        <Navigation
          tag="button"
          icon="close"
          className={closeClassName}
          onClick={onToggle}
          dataQaIcon="iconCloseMenuItemsCta"
        />
      )}
    </>
  );
};

Menu.propTypes = {
  isB2B: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  basketCount: PropTypes.number.isRequired,
  onToggle: PropTypes.func.isRequired,
  classNames: MenuPropType,
  isHidden: PropTypes.bool,
};

Menu.defaultProps = {
  classNames: {},
  isHidden: false,
};

Menu.displayName = 'Menu';

export default Menu;
